<template>
  <el-dialog title="订单发货" v-model="sendDialog" width="25%">
    <el-form ref="sendForm" :model="addRow" label-width="80px">
      <el-form-item label="发货快递">
        <simple-dict tipsValue="发货快递" style="width: 100%" dict-type="express" v-model="addRow.express"></simple-dict>
      </el-form-item>
      <el-form-item label="快递单号">
        <el-input v-model="addRow.expressCode"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
       <el-button @click="sendDialog = false">取 消</el-button>
       <el-button type="primary" @click="sendSave()">确 定</el-button>
      </span>
  </el-dialog>
</template>

<script>
import SimpleDict from "@/components/dict/SimpleDict.vue";

export default {
  name: "send-goods",
  components: {SimpleDict},
  data() {
    return {
      sendDialog:false,
      addRow:{id:"",express:"",expressCode:""}
    }
  },
  mixins: [tableBase],
  methods: {
    openDialog(id,express,expressCode) {
      this.addRow = {id:id,express:express,expressCode:expressCode};
      this.sendDialog = true;
    },
    sendSave(){
      this.$refs["sendForm"].validate((valid) => {
        if (valid) {
          this.simplePost( "/api/mgr/shop/business/order/orderDeliver", this.addRow, result => {
            this.sendDialog = false;
            this.$emit("success");
          });
        }
      })
    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
